// components/Footer.jsx
import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-green-800 text-white py-10 px-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <h4 className="font-bold">Secretaria de Saúde</h4>
          <p>(62) 3307-7600</p>
          <p>Segunda a Sexta das 07h às 17h</p>
          <p>saude@ceres.go.gov.br</p>
        </div>
        <div>
          <h4 className="font-bold">Serviços</h4>
          <ul className="text-sm space-y-1">
            <li>Agendamento</li>
            <li>Unidades</li>
            <li>Vacinação</li>
            <li>Farmácia</li>
            <li>Ouvidoria</li>
          </ul>
        </div>
        <div>
          <h4 className="font-bold">Localização</h4>
          <p>Praça Cívica, s/n - Ceres, GO</p>
          <a href="#" className="underline text-sm">Ver no mapa</a>
        </div>
      </div>
      <div className="text-center mt-8 text-xs">
        Desenvolvido pela Prefeitura de Ceres
      </div>
    </footer>
  );
}